module.exports = __webpack_public_path__ + "static/img/caida.e318ab6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconos/svg/caida.svg
// module id = 4sFk
// module chunks = 1